import React, { useState, useEffect, useRef } from 'react';
import { Button, Form } from 'react-bootstrap';

const BASE_URL = 'https://whapi.infosware-test.in'; // Define base URL

function ItemsForm({ item, onCancel, onSave }) {
    const [formData, setFormData] = useState({
        id: '',
        name: '',
        quantity: '',
        packing: 'SelectPacking',
        sku: ''
    });

    const skuRef = useRef(null);

    useEffect(() => {
        if (item) {
            setFormData(item);
        }
    }, [item]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handlePackingChange = (e) => {
        const { value } = e.target;
        console.log('Packing changed to:', value);
        setFormData({
            ...formData,
            packing: value,
            quantity: value === 'Single' ? '1' : formData.quantity,
        });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            let response;
            if (formData.id) {
                response = await fetch(`${BASE_URL}/items/${formData.id}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formData),
                });
            } else {
                response = await fetch(`${BASE_URL}/items`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formData),
                });
            }

            const data = await response.json();

            if (response.ok) {
                alert('Item saved successfully!');
                setFormData({
                    id: '',
                    name: '',
                    quantity: '',
                    packing: 'SelectPacking',
                    sku: ''
                });
                onSave(data); // Ensure onSave is called with the correct data
            } else {
                alert(`Error: ${data.message}`);
            }
        } catch (error) {
            console.error('Error saving item:', error);
            alert('Failed to save item. Please try again.');
        }
    };

    return (
        <div>
            <h3 className='mt-1 p-4 bg-secondary text-white'>{item ? 'Edit Item' : 'New Item'}</h3>
            <Form className='container p-4 mb-4 shadow-sm rounded bg-white' onSubmit={handleSubmit}>
                <Form.Group controlId="name">
                    <Form.Label>Product Name</Form.Label>
                    <Form.Control type="text" name="name" value={formData.name} onChange={handleChange} required />
                </Form.Group>
                <Form.Group controlId="packing">
                    <Form.Label>Packing</Form.Label>
                    <Form.Control as="select" name="packing" value={formData.packing} onChange={handlePackingChange} required>
                        <option value="SelectPacking">Select packing</option>
                        <option value="Single">Single</option>
                        <option value="Box">Box</option>
                    </Form.Control>
                </Form.Group>
                <Form.Group controlId="quantity">
                    <Form.Label>Quantity</Form.Label>
                    <Form.Control
                        type="text"
                        name="quantity"
                        value={formData.quantity}
                        onChange={handleChange}
                        readOnly={formData.packing === 'Single'}
                        required
                    />
                </Form.Group>
                <Form.Group controlId="sku">
                    <Form.Label>SKU</Form.Label>
                    <div className="d-flex">
                        <Form.Control
                            type="text"
                            placeholder="Enter SKU"
                            name="sku"
                            value={formData.sku}
                            onChange={handleChange}
                            ref={skuRef}
                            className="me-2 w-100"
                        />
                    </div>
                </Form.Group>
                <Button className='mt-3' variant="danger" onClick={onCancel}>Back</Button>{' '}
                <Button className='mt-3' variant="primary" type="submit">Save</Button>
            </Form>
        </div>
    );
}

export default ItemsForm;
